import React, { useCallback } from "react";

import RefreshIcon from "../icons/refresh.svg";
import TrashIcon from "../icons/trash.svg";

export const ReasonItem = ({ reason, onDelete, onUndo }) => {
  const handleDelete = useCallback(() => {
    onDelete(reason.id);
  }, [onDelete, reason.id]);

  const handleUndo = useCallback(() => {
    onUndo(reason.id);
  }, [onUndo, reason.id]);

  return (
    <div
      className={`reason-card ${reason.deactivated ? "is-deactivated" : ""}`}
    >
      <div className="reason-card__text">{reason.text}</div>
      <div className="reason-card__actions">
        {reason.deactivated ? (
          <button
            aria-label="Undo deactivate"
            className="reason-action-button"
            onClick={handleUndo}
          >
            <img
              src={RefreshIcon}
              alt="Undo"
              className="reason-action-button-icon"
            />
          </button>
        ) : (
          <button
            aria-label="Deactivate"
            className="reason-action-button"
            onClick={handleDelete}
          >
            <img
              src={TrashIcon}
              alt="Undo"
              className="reason-action-button-icon"
            />{" "}
          </button>
        )}
      </div>
    </div>
  );
};
